const server = 'https://api.test.ubaristi.diversius.com/';

export const environment = {
  production: true,
  apiUrl: `${ server }v1/`,
  imageUrl: `${ server }image/`,
  toasterTimeout: 6000,
  pageElements: 50,
  printConsoleError: false
};



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/environments/environment.ts